import { Action } from 'redux';

import { SetLayoutType } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { LayoutType } from '../state/LayoutType';


export interface SetLayoutTypeAction extends Action {
  layoutType: LayoutType;
}

export function setLayoutType(layoutType: LayoutType): SetLayoutTypeAction {
  return {
    type: SetLayoutType,
    layoutType: layoutType
  };
}

export const isSetLayoutTypeAction = isActionFactory<SetLayoutTypeAction>(SetLayoutType);
